import { submitGoogleAccountAuthCode } from "@/api/custom";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const GoogleAccountOauth: React.FC = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const nagivate = useNavigate();

  useEffect(() => {
    if (code) {
      submitGoogleAccountAuthCode(code)
        .then(() => nagivate("/home/meetinghub"))
        .catch(() => nagivate("/home/meetinghub"));
    } else {
      nagivate("/home/meetinghub");
    }
  }, [code]);

  return <div>Login Finished. Redirecting...</div>;
};

export default GoogleAccountOauth;
